module.exports = __webpack_public_path__ + "assets/img/upgif.0850b993.gif";